import EntityModel from '@/common/models/entity-model';

export class EmailAuthorizationModel extends EntityModel {
    static Types = {
        none: 'none',
        plain: 'plain',
        login: 'login',
        cramMD5: 'cram-md5',
    };

    hydrate({type = EmailAuthorizationModel.Types.none, ...specialProps} = {}) {
        this.type = type;
        this.username = null;
        this.password = null;
        if (this.type !== EmailAuthorizationModel.Types.none) {
            const {username = null, password = null} = specialProps;
            this.username = username;
            this.password = password;
        }
    }

    get requiresCredentials() {
        return this.type !== EmailAuthorizationModel.Types.none;
    }

    getPayload() {
        const payload = {
            type: this.type,
        };
        if (this.type !== EmailAuthorizationModel.Types.none) {
            payload.username = this.username;
            payload.password = this.password;
        }
        return payload;
    }
}

export default class EmailCredentialModel extends EntityModel {
    static Types = {
        awsSES: 'awsSES',
        mailgun: 'mailgun',
        sendGrid: 'sendGrid',
        smtp: 'smtp',
        postmark: 'postmark',
    };

    static SMTPEncryptions = {
        none: 'none',
        tls: 'tls',
        ssl: 'ssl',
    };

    hydrate({type = EmailCredentialModel.Types.smtp, ...specialProps} = {}) {
        this.type = type;
        if (type === EmailCredentialModel.Types.awsSES) {
            ({
                key: this.key = null,
                secret: this.secret = null,
                region: this.region = null,
                configurationSetName: this.configurationSetName = null,
            } = specialProps);
        } else if (type === EmailCredentialModel.Types.mailgun) {
            ({
                emailFrom: this.emailFrom = null,
                apiKey: this.apiKey = null,
                domain: this.domain = null,
            } = specialProps);
        } else if (type === EmailCredentialModel.Types.sendGrid) {
            ({
                apiKey: this.apiKey = null,
            } = specialProps);
        } else if (type === EmailCredentialModel.Types.postmark) {
            ({
                serverApiToken: this.serverApiToken = null,
            } = specialProps);
        } else {
            ({
                host: this.host = null,
                port: this.port = 465,
                encryption: this.encryption = EmailCredentialModel.SMTPEncryptions.ssl,
                auth: this.auth,
            } = specialProps);
            this.auth = new EmailAuthorizationModel(this.auth || undefined);
        }
    }

    getPayload() {
        if (this.type === EmailCredentialModel.Types.awsSES) {
            return {
                type: this.type,
                key: this.key,
                secret: this.secret,
                region: this.region,
                configurationSetName: this.configurationSetName,
            };
        } if (this.type === EmailCredentialModel.Types.mailgun) {
            return {
                type: this.type,
                emailFrom: this.emailFrom,
                apiKey: this.apiKey,
                domain: this.domain,
            };
        } if (this.type === EmailCredentialModel.Types.sendGrid) {
            return {
                type: this.type,
                apiKey: this.apiKey,
            };
        } if (this.type === EmailCredentialModel.Types.postmark) {
            return {
                type: this.type,
                serverApiToken: this.serverApiToken,
            };
        }
        return {
            host: this.host,
            port: Number(this.port),
            encryption: this.encryption,
            auth: this.auth.getPayload(),
        };
    }
}
